import moment from 'moment';
import {Utils} from 'app/utils';

export class BookingDetailsTransaction {
    Id!: number;
    CreatedAt!: Date;
    TransactionTypeId!: number;
    TransactionTypeText!: string;
    PaymentMethodId!: number;
    PaymentMethodText!: string;
    TransactionAmount!: number;
    PartnerTXID!: string;
    Status!: string;
    OperationTypeId!: number;
    OperationTypeText!: string;

    public get TransactionAmountText() {
        return this.formatMoney(this.TransactionAmount);
    }

    public get TransactionDate() {
        return this.formatDate(this.CreatedAt);
    }

    public get TransactionTime() {
        return this.formatTime(this.CreatedAt);
    }

    public get TransactionTimeNoSeconds() {
        return this.formatTimeNoSeconds(this.CreatedAt);
    }

    constructor(payload: { [key: string]: any }) {
        Object.assign(this, payload);
    }

    private formatDate(date: Date | null): string {
        return date ? moment(Utils.utcToLocalDate(date)).format('D MMM YYYY') : '';
    }

    private formatTime(time: Date | null): string {
        return time ? moment(Utils.utcToLocalDate(time)).format('hh:mm:ss') : '';
    }

    private formatTimeNoSeconds(time: Date | null): string {
        return time ? moment(Utils.utcToLocalDate(time)).format('hh:mm') : '';
    }

    private formatMoney(amount: number): string {
        return amount ? `₱ ${amount.toFixed(2)}` : '';
    }
}
